// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BreadcrumbFirstItem{color:#000;display:block;flex-grow:1;font-size:.8125rem;overflow:hidden;padding:.5rem;-webkit-text-decoration:underline;text-decoration:underline;text-overflow:ellipsis;white-space:nowrap}@media(min-width:1024px){.BreadcrumbFirstItem{padding:.25rem 1ch}}.BreadcrumbFirstItem>svg{margin-top:-.1875rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
